module.exports = __webpack_public_path__ + "static/media/hackathon.43f3b9f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/OpenChallenges/hackathon.svg
// module id = 181
// module chunks = 0